document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.merken-button');

  let merkenListe = JSON.parse(localStorage.getItem('merkenListe')) || [];

  buttons.forEach(function (button) {
    const wrapper = button.closest('[data-product-handle]');
    if (!wrapper) return;

    const productHandle = wrapper.dataset.productHandle;
    if (!productHandle) return;

    const buttonText = button.querySelector('.button-text');

    // Ustawienie początkowego stanu
    if (merkenListe.includes(productHandle)) {
      button.classList.add('active');
      button.setAttribute('aria-pressed', 'true');
      button.style.color = 'red';
      if (buttonText) buttonText.textContent = 'Gespeichert';
    }

    // Obsługa kliknięcia
    button.addEventListener('click', function () {
      merkenListe = JSON.parse(localStorage.getItem('merkenListe') || '[]');
      const index = merkenListe.indexOf(productHandle);

      if (index === -1) {
        // ✅ TUTAJ wchodzi produkt do localStorage
        merkenListe.push(productHandle);
        localStorage.setItem('merkenListe', JSON.stringify(merkenListe));
        button.classList.add('active');
        button.setAttribute('aria-pressed', 'true');
        button.style.color = 'red';
        if (buttonText) buttonText.textContent = 'Gespeichert';
        showToast("✅ Produkt wurde gespeichert!");
      } else {
        merkenListe.splice(index, 1);
        localStorage.setItem('merkenListe', JSON.stringify(merkenListe));
        button.classList.remove('active');
        button.setAttribute('aria-pressed', 'false');
        button.style.color = '';
        if (buttonText) buttonText.textContent = 'Merken';
        showToast("ℹ️ Produkt wurde entfernt.");
      }

      updateHeaderMerkenIcon();
    });
  });

  // Aktualizacja ikony w headerze
  function updateHeaderMerkenIcon() {
    const headerButton = document.querySelector('.merken-header-button');
    if (!headerButton) return;
    const headerText = headerButton.querySelector('.button-text');
    const merkenListe = JSON.parse(localStorage.getItem('merkenListe') || '[]');

    if (merkenListe.length > 0) {
      headerButton.classList.add('active');
      headerButton.setAttribute('aria-pressed', 'true');
      headerButton.style.color = 'red';
      if (headerText) headerText.textContent = 'Gespeichert';
    } else {
      headerButton.classList.remove('active');
      headerButton.setAttribute('aria-pressed', 'false');
      headerButton.style.color = '';
      if (headerText) headerText.textContent = 'Merken';
    }
  }

  // Toast
  function showToast(message) {
    let toast = document.getElementById('toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'toast';
      toast.style.cssText = 'position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); background: #333; color: white; padding: 10px 20px; border-radius: 5px; z-index: 9999;';
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.add('show');

    setTimeout(() => {
      toast.classList.remove('show');
    }, 2500);
  }

  // Obsługa kliknięcia w headerze
  const headerButton = document.querySelector('.merken-header-button');
  if (headerButton) {
    headerButton.addEventListener('click', function () {
      window.location.href = '/pages/merken';
    });

    updateHeaderMerkenIcon();
  }
});
